import { useEffect, useState } from 'react';
// function to compare 2 strings without case sensitive and also validate undefined
const compareStrings = (description, title, anotherTitle) => {
    if (description && title && !anotherTitle)
        return description.toLowerCase() === title.toLowerCase();
    if (description && anotherTitle)
        return description.toLowerCase() === anotherTitle.toLowerCase();
    return false;
};
// function that receives 2 string params, parse the first one to number and return the sum of both and validate common errors
const sumStringsV2 = (str1, str2, isStr2Negative) => {
    const number1 = parseFloat(str1);
    const number2 = isStr2Negative ? -1 * parseFloat(str2) : parseFloat(str2);
    if (isNaN(number1) && isNaN(number2))
        return 0;
    if (isNaN(number1))
        return number2;
    if (isNaN(number2))
        return number1;
    console.log('isStr2Negative:', isStr2Negative);
    console.log('number1:', number1);
    console.log('number2:', number2);
    return number1 + number2;
};
// function to round a number to 1 decimal
const roundNumber = (num) => {
    return Math.round((num + Number.EPSILON) * 10) / 10;
};
const MAIN_CATEGORIES = [
    { title: 'EMPTY', color: '#D3D3D3', value: 100, amount: 0 },
    { title: 'Housing', color: '#695CFF', value: 0, amount: 0 },
    { title: 'Insurance', color: '#2AB1EB', value: 0, amount: 0 },
    { title: 'Transportation', color: '#FFB800', value: 0, amount: 0 },
    { title: 'Food', color: '#F48218', value: 0, amount: 0 },
    { title: 'Entertainment', color: '#00CFB6', value: 0, amount: 0 },
    { title: 'Utilities', color: '#65C702', value: 0, amount: 0 },
    { title: 'Taxes', color: '#FF63D3', value: 0, amount: 0 },
    { title: 'Investments', color: '#000080', value: 0, amount: 0, anotherTitle: 'brokerage' },
    { title: 'Savings', color: '#F04A4A', value: 0, amount: 0, anotherTitle: 'Pocket' }
];
export const useChart = ({ items }) => {
    const [chartDataArray, setChartDataArray] = useState(MAIN_CATEGORIES);
    const [total, setTotal] = useState(0);
    const initValues = () => {
        const localCategories = MAIN_CATEGORIES.filter(i => i.title !== 'EMPTY').map(item => (Object.assign({}, item)));
        const totalAmountSpent = items.reduce((accumulator, currentValue) => accumulator + Number(currentValue.amount), 0);
        console.log('items==>', items);
        items.forEach(item => {
            var _a, _b, _c;
            const categoryIndex = localCategories.findIndex(category => {
                var _a, _b, _c, _d;
                return compareStrings(((_b = (_a = item.accountTo) === null || _a === void 0 ? void 0 : _a.savingCategory) === null || _b === void 0 ? void 0 : _b.description) || ((_d = (_c = item.accountTo) === null || _c === void 0 ? void 0 : _c.accountType) === null || _d === void 0 ? void 0 : _d.description), category.title, category.anotherTitle);
            });
            // we have to rest the saving outgoing transactions
            const isOutgoingSavingTransaction = ((_c = (_b = (_a = item.accountFrom) === null || _a === void 0 ? void 0 : _a.accountType) === null || _b === void 0 ? void 0 : _b.description) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === 'pocket';
            console.log('isOutgoingSavingTransaction==>', isOutgoingSavingTransaction);
            let category = null;
            if (categoryIndex === -1) {
                category = localCategories[localCategories.length - 1];
            }
            else {
                category = localCategories[categoryIndex];
            }
            category.amount = sumStringsV2(category.amount, item.amount, isOutgoingSavingTransaction);
            category.value = sumStringsV2(category.amount, item.amount, isOutgoingSavingTransaction);
            // localCategories[categoryIndex] = category;
        });
        const resultCategories = localCategories.map(category => {
            return Object.assign(Object.assign({}, category), { value: roundNumber((Number(category.amount) * 100.0) / totalAmountSpent) });
        });
        // console.log('==>', JSON.stringify(resultCategories));
        // console.log('==>totalAmountSpent:', totalAmountSpent);
        setChartDataArray(resultCategories);
        setTotal(totalAmountSpent);
    };
    useEffect(() => {
        if (items.length > 0) {
            initValues();
        }
    }, [items.length]);
    return {
        chartData: chartDataArray,
        total
    };
};
